import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[togglePassword]'
})
export class TogglePasswordDirective {

  private _shown = false;
  private span:any;
  private parent:any;
  constructor(private el: ElementRef , private renderer :Renderer2) {
     this.parent = this.el.nativeElement.parentNode;
    this.span = document.createElement('span');
    this.span.classList.add('show-password');
    this.span.addEventListener('click', () => {
      this.toggle(this.span);
    });
    
}
  @HostListener('input', ['$event.target.value'])
  onInputChange(value: string) { 
   if  (value!=""){
    this.parent.appendChild(this.span);
  }
  else{
    this.parent.removeChild(this.span);
  }
  }
 


  toggle(span: HTMLElement) {
    this._shown = !this._shown;
    if (this._shown) {
      this.el.nativeElement.setAttribute('type', 'text');
      span.classList.add('crossed');
    } else {
      this.el.nativeElement.setAttribute('type', 'password');
      span.classList.remove('crossed');
    }
  }
}

function onKeyInput(event: Event, EventTarget: { new(): EventTarget; prototype: EventTarget; }) {
  throw new Error('Function not implemented.');
}
